import { throttle } from 'lodash'

// try to handle passive events
let passiveEventSupported = false
try {
  const opts = Object.defineProperty({}, 'passive', {
    // eslint-disable-next-line getter-return
    get() {
      passiveEventSupported = true
    },
  })
  window.addEventListener('test', null, opts)
} catch (e) {
  null
}
// if they are supported, setup the optional params
// FALSE doubles as the default CAPTURE value

const passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false

export const addPassiveListener = (type, callback, container = window, timeout = 300) => {
  const throttledCallback = timeout > 0 && !passiveEventSupported ? throttle(callback, timeout) : callback
  container.addEventListener(type, throttledCallback, passiveEvent)
  return () => {
    container.removeEventListener(type, throttledCallback, passiveEvent)
  }
}
